const types = {
  SHOW_LOADER: 'SHOW_LOADER',
};

export default types;